import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MonoTypeOperatorFunction, Observable, of, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen, tap } from 'rxjs/operators';

@Injectable()
export class ErrorRetryInterceptor implements HttpInterceptor {
  minRetryDelay = 500;
  maxRetryDelay = 3000;
  retryMaxAttempts = 2;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(this.retryAfterDelay());
  }

  retryAfterDelay(): MonoTypeOperatorFunction<HttpEvent<unknown>> {
    return retryWhen(errors => {
      return errors.pipe(
        mergeMap((err, count) => {
          // throw error when we've retried ${retryMaxAttempts} number of times and still get an error
          if (!(err instanceof HttpErrorResponse)) return throwError(() => new Error(err));
          if (count === this.retryMaxAttempts) return throwError(() => err);
          if (!err?.error?.code) return throwError(() => err);
          const code = err.error.code;
          const message = err.error.message;
          if (code !== 'server_exception' || !message?.includes('rate limit exceeded')) return throwError(() => err);
          const retryDelay = Math.floor(Math.random() * this.maxRetryDelay - this.minRetryDelay + this.minRetryDelay);
          return of(err).pipe(
            tap(error => console.log(`Retrying ${error.url}. Retry count ${count + 1}`)),
            mergeMap(() => timer(retryDelay))
          );
        })
      );
    });
  }
}
